import React from 'react'
import { handleGTM, GTM_APP_DETAILS_NAME } from '../utils/utils'
import { App } from '../utils/objects'

/**
 *
 */
const Video = ({ sources, attributes, app }: { sources: Record<string, any>[], app: App, attributes?: React.VideoHTMLAttributes<HTMLVideoElement> }): JSX.Element => {
    const videoOnPlay = (ev: React.SyntheticEvent<HTMLVideoElement, Event>) => {
        const videoSrc = (ev.currentTarget as HTMLVideoElement).currentSrc
        const appTitleWithUnderscores = app.title.toLowerCase().replace(/\s+/g, '_')
        handleGTM({
            action: GTM_APP_DETAILS_NAME,
            label: 'video_played',
            event: `PDC_${appTitleWithUnderscores}_video_played`,
            value: videoSrc,
            other: {
                items: [{ item_name: app.title }]
            }
        })
        if (attributes && attributes.onPlay) attributes.onPlay(ev)
    }

    return (
        <video controls preload='metadata' {...attributes} onPlay={videoOnPlay}>
            {sources.map((source, index) => <source key={index} {...source} src={source.src}></source>)}
            Your browser does not support the video tag.
        </video>
    )
}

/**
 *
 */
export { Video }
